<div class="booking-detail-cont animated {{animation}}">
  <div class="header">
    <div class="reservation-header">
      <ng-container [ngSwitch]="viewType">
        <ng-container *ngSwitchCase="packageBookingDetailViewType.HOTEL">
          <span>{{'PACKAGES_MODULES.PACKAGE_BOOKING.HOTEL_BOOK_DETAIL' | transloco}}</span>
        </ng-container>
        <ng-container *ngSwitchCase="packageBookingDetailViewType.AIR">
          <span>{{'PACKAGES_MODULES.PACKAGE_BOOKING.AIR_BOOK_DETAIL' | transloco}}</span>
        </ng-container>
        <ng-container *ngSwitchCase="packageBookingDetailViewType.SIMPLE">
          <span>{{'PACKAGES_MODULES.PACKAGE_BOOKING.PACKAGE_DETAIL' | transloco}}</span>
        </ng-container>
      </ng-container>
    </div>
    <a class="close-button" (click)="goBack()"><i aria-hidden="true" class="icon-close"></i></a>
  </div>
  <div *ngIf="hasValidators" class="body">
    <app-package-air-reservation
      [hotelValidation]="hotelValidation"
      [airValidation]="airValidation"
      [flightClass]="flightClass"
      [provider]="provider"
      [airValidationSector]="airValidationSector | airValidationSectorVm"
      [travelType]="travelType"
      [sectorSelected]="sectorSelected"
      [passengerArrangement]="passengerArrangement"
      [packagePrice]="packagePrice"
      [travelDetailProvider]="travelDetailProvider"
      [viewType]="viewType"
      [conversionRate]="conversionRate"
      [isInternational]="isInternational"
      (showMoreHotelInfo)="showPackageHotelDetail()"
      (showMoreAirInfo)="showPackagAirDetail($event)">
    </app-package-air-reservation>
  </div>
</div>

<router-outlet name="inner-detail"></router-outlet>